var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.37109 16.7713C3.87109 18.0313 3.37109 21.7713 3.37109 21.7713C3.37109 21.7713 7.11109 21.2713 8.37109 19.7713C9.08109 18.9313 9.07109 17.6413 8.28109 16.8613C7.8924 16.4903 7.38039 16.2759 6.84332 16.2593C6.30625 16.2427 5.78197 16.425 5.37109 16.7713Z",
    stroke: "#C6C7F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8711 15.2713L9.87109 12.2713M12.8711 15.2713C14.2679 14.74 15.608 14.07 16.8711 13.2713M12.8711 15.2713V20.2713C12.8711 20.2713 15.9011 19.7213 16.8711 18.2713C17.9511 16.6513 16.8711 13.2713 16.8711 13.2713M9.87109 12.2713C10.4032 10.8907 11.0733 9.56733 11.8711 8.32126C13.0363 6.45825 14.6587 4.92431 16.5841 3.86535C18.5095 2.8064 20.6738 2.25763 22.8711 2.27126C22.8711 4.99126 22.0911 9.77126 16.8711 13.2713M9.87109 12.2713H4.87109C4.87109 12.2713 5.42109 9.24126 6.87109 8.27126C8.49109 7.19126 11.8711 8.27126 11.8711 8.27126",
    stroke: "#C6C7F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.ba39bef77560e0f32259c75663d083ea.svg";
export { ForwardRef as ReactComponent };